import {
  TYPE2CLASS
} from '../core/icon-class';
import {
  Fact
} from '../common/fact';
import {
  PATH_STRING_SEPARATOR
} from '../common/config.js';
import {
  IncidentsModalController
} from './add-to-incidents/incidents-modal.component';
import {
  agentTime
}
from './table-view';

class FactThumbController {
  constructor(
    $scope,
    $element,
    $timeout,
    RouterService,
    AlertModalService,
    $modal,
    $http,
    FaceService,
    SpecialModalService,
  ) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.isImage = Fact.isImage;
    this.router = RouterService;
    this.AlertModalService = AlertModalService;
    this.sep = PATH_STRING_SEPARATOR;

    $scope.addToIncidents = () => {
      this.$scope.fact = this.fact;
      this.modalInstance = $modal
        .open({
          template: require('./add-to-incidents/incidents-modal.component.html'),
          controller: IncidentsModalController,
          scope: $scope,
        })
        .result.then(() => {
          $scope.fact = this.fact;
        }, err => {
          this.AlertModalService.open(`${err.status} ${err.status ? err.statusText :''}`, err.data);
        });
    };

    $scope.toNeighbourEvents = () => {
      this.router.needToShowFact = {
        fact: this.fact,
        date: this.fact.local_time
      };
      this.router.toNeighbourEvents();
      this.router.filterChanged();
    };

    $scope.findSimular = () => {
      $scope.router.findSimular($scope.fact.id);
    };

    $scope.deleteEvent = () => {
      SpecialModalService.deleteEvent(this.fact.id, function onSuccess() {
        $scope.$emit('reload');
      });
    };

    $element.ready(() => {
      this.scrollElement = this.$element.closest('#fact-thumbnail-container');
      this.$timeout(() => {
        this.setNeedToShowThumb();
      }, 200);
      this.scrollElement.on('scroll', e => {
        this.setNeedToShowThumb();
      });
    });
  }

  setNeedToShowThumb() {
    const top = this.$element.position().top;
    this.$scope.needToShowThumb = top > -200 && top < this.scrollElement.height() + 200;
  }

  get agentTime() {
    if (this._agentTime) return this._agentTime;
    if (this.fact) {
      this._agentTime = agentTime(this.fact);
      return this._agentTime;
    }
    return '';
  }

  get icon() {
    return this.fact && TYPE2CLASS[this.fact['agent_eventtype.name']];
  }
}

export const FactThumbComponent = {
  bindings: {
    filter: '<',
    fact: '<',
    openImage: '<',
    toUserNearestScreenshot: '<',
    listType: '<',
    selected: '<',
  },
  controller: FactThumbController,
  template: require('./fact-thumb.component.html'),
};



// WEBPACK FOOTER //
// ./src/facts/fact-thumb.component.js